import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { MONEY_FORMAT } from 'constants/formats';
import { DateBox, NumberBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';

import {
  useChangeEmployeeSalaryConfigurationMutation,
  useCreateEmployeeSalaryConfigurationMutation,
  useLazyGetEmployeeSalaryConfigurationDetailQuery,
} from 'bus/employeeSalary/services/services';
import { EmployeeSalary } from 'bus/employeeSalary/types';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
};

const initialForm: EmployeeSalary = {
  id: null,
  employeeId: null,
  salaryType: null,
  salary: 0,
  comment: '',
  dateBegin: '',
  additionalPayment: 0,
  additionalPaymentType: 0,
  shiftSalary: 0,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id }) => {
  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [getEmployeeSalaryConfigurationDetail] = useLazyGetEmployeeSalaryConfigurationDetailQuery();
  const [changeEmployeeSalaryConfiguration, { isLoading: isLoadingChange }] =
    useChangeEmployeeSalaryConfigurationMutation();
  const [createEmployeeSalaryConfiguration, { isLoading: isLoadingCreate }] =
    useCreateEmployeeSalaryConfigurationMutation();
  const [type, setTypes] = useState<any>([]);
  const [additionalPaymentTypes, setAdditionalPaymentTypes] = useState<any>([]);

  const [form, setForm] = useState<EmployeeSalary>(initialForm);

  const store: any = useMemo(() => {
    const defaultFilter = [
      [['postId', '<>', 1], 'and', ['postId', '<>', 2], 'and', ['postId', '<>', 3]],
      'and',
      ['status', '=', 0],
    ];
    return $createDataSource('/v1/employee', 'id', { defaultFilter });
  }, []);

  const storeTypes = async () => {
    const data = await $createDataSource('/v1/EmployeeSalary/types', 'id').load();
    setTypes(data);
  };

  const getAdditionalPaymentTypes = async () => {
    const data = await $createDataSource('/v1/EmployeeSalary/additionalPaymentTypes', 'id').load();
    setAdditionalPaymentTypes(data);
  };

  const onShown = async () => {
    storeTypes();
    getAdditionalPaymentTypes();
    if (id) {
      const result = await getEmployeeSalaryConfigurationDetail({ id });
      setForm(result.data!);
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const loading = isLoadingChange || isLoadingCreate;

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        await changeEmployeeSalaryConfiguration(form);
      } else {
        const temp = { ...form };
        delete temp.id;
        await createEmployeeSalaryConfiguration({ ...temp });
      }
      changeVisible(false);
      refresh();
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="З/П сотрудника"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup title="Выплата">
                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, dateBegin: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label="Сотрудник" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={store}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.employeeId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, employeeId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите сотрудника" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите сотрудника" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Тип" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={type}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.salaryType}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, salaryType: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Тип" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Тип" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        {form.salaryType === 0 && (
                          <AppFiledBox label="Стоимость смены" labelTop>
                            <NumberBox
                              stylingMode="underlined"
                              placeholder="0"
                              format={MONEY_FORMAT}
                              value={form.shiftSalary}
                              onValueChanged={(e) => {
                                setForm((prev) => ({ ...prev, shiftSalary: e.value }));
                              }}
                            >
                              <Validator>
                                <RequiredRule message="Заполните поле Стоимость смены" />
                              </Validator>
                            </NumberBox>
                          </AppFiledBox>
                        )}

                        <AppFiledBox label="Оклад" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.salary}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, salary: e.value }));
                            }}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Сумма" />
                            </Validator>
                          </NumberBox>
                        </AppFiledBox>
                      </AppGroup>
                      <AppGroup title="Доп. выплата">
                        <AppFiledBox label="Тип доп. выплаты" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={additionalPaymentTypes}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.additionalPaymentType}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, additionalPaymentType: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Тип" closeOnOutsideClick={true} showTitle={false} />
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Сумма доп выплаты" labelTop>
                          <NumberBox
                            stylingMode="underlined"
                            placeholder="0"
                            format={MONEY_FORMAT}
                            value={form.additionalPayment}
                            onValueChanged={(e) => {
                              setForm((prev) => ({ ...prev, additionalPayment: e.value }));
                            }}
                          />
                        </AppFiledBox>
                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={loading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
